/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/*
 *
 * Action types for ACESWithdrawal.
 *
 */

import { ReduxUtils } from '@spm/core';

const POST_SUBMITTED_APPLICATIONS_APPLICATION_PROGRAMS_ACES_WITHDRAWAL_REQUEST =
  ReduxUtils.generatePostActionTypes(
    'ua-library',
    `ACESWITHDRAWAL/POST_SUBMITTED_APPLICATIONS_APPLICATION_PROGRAMS_ACES_WITHDRAWAL_REQUEST`
  );

export { POST_SUBMITTED_APPLICATIONS_APPLICATION_PROGRAMS_ACES_WITHDRAWAL_REQUEST };
